export function isString(value: any): value is string {
  return typeof value === "string";
}

export function isObject(obj: any): obj is object {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj);
}

export function isUndefined(value: unknown): value is undefined {
  return typeof value === "undefined";
}

export function isDate(value: unknown): value is Date {
  return Object.prototype.toString.call(value) === "[object Date]";
}

export function isNullOrWhiteSpace(value: unknown): value is null | " " {
  return (
    typeof value === "undefined" ||
    value === null ||
    (isString(value) && value.match(/^ *$/) !== null)
  );
}

export function isNullOrEmpty(value: unknown): value is null | "" {
  return typeof value === "undefined" || value === null || (isString(value) && value === "");
}
